import { createTypedNode } from './middleware'
import { SchemaMustacheDefinition } from './SchemaDefinition'
import {
  ExpressionDefinition,
  JSExpressionDefinition,
  MustacheDefinition
} from './TypedDefinition'
import { MustacheNode } from './TypedNode'
import { MustacheComponent } from './ViewComponent'

import type {
  PluginMiddlewares,
  PluginVisitors,
  RehajePlugin
} from '@rehaje/core'

export interface MustachePluginProps {
  /**
   * 启用常量优化，默认关闭
   */
  enableConstantOpt?: boolean

  /**
   * 启用错误收集能力，默认关闭
   */
  enableErrorCapture?: boolean

  /**
   * 启用自动重命名能力，默认关闭
   */
  enableRefactor?: boolean

  /**
   * 沙箱代理器
   */
  getProxyHandler?: (node: MustacheNode) => ProxyHandler<any>
}

/**
 * 插值表达式插件
 */
export class MustachePlugin implements RehajePlugin {
  middlewares: PluginMiddlewares = {}
  props: MustachePluginProps
  visitors: PluginVisitors

  constructor(props?: MustachePluginProps) {
    this.props = {
      enableConstantOpt: false,
      enableErrorCapture: false,
      enableRefactor: false,
      ...props
    }
    this.visitors = {
      components: {
        Expression: MustacheComponent,
        JSExpression: MustacheComponent,
        Mustache: MustacheComponent
      },
      definitions: {
        Expression: ExpressionDefinition,
        JSExpression: JSExpressionDefinition,
        Mustache: MustacheDefinition,
        'Schema.Expression': SchemaMustacheDefinition,
        'Schema.JSExpression': SchemaMustacheDefinition,
        'Schema.Mustache': SchemaMustacheDefinition
      },
      nodes: {
        Expression: MustacheNode,
        JSExpression: MustacheNode,
        Mustache: MustacheNode
      }
    }
    if (this.props.enableConstantOpt) {
      this.middlewares = { createTypedNode }
    }
  }

  /**
   * 浏览器编译产物离线强缓存解决方案
   * 标准 async/await API(适配 react19+)
   * @example
   *  const App = ()=>{
   *   use(loadMustacheStorage())
   *   const store = useMemo(()=>createStore(dsl,{
   *     plugins:[new MustachePlugin()]
   *   }))
   * }
   */
  static loadMustacheStorage = async () => {
    return MustacheNode.loadMustacheStorage()
  }

  /**
   * 浏览器编译产物离线强缓存解决方案
   * 适配 react16+ 使用的 suspense api
   * @example
   * const App = ()=>{
   *   useMustacheStorage()
   *   const store = useMemo(()=>createStore(dsl,{
   *     plugins:[new MustachePlugin()]
   *   }))
   * }
   */
  static useMustacheStorage() {
    return MustacheNode.useMustacheStorage()
  }
}
